import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { HealthHistoryType } from '@libs/store';
import { DropdownItem, TooltipModule } from '@libs/ui-lib';
import { HealthHistoryItemComponent, HealthHistoryItemVM } from '../health-history-item/health-history-item.component';
import { HealthHistoryItemDeleteData, HealthHistoryItemEditData } from '../health-history-item-edit/health-history-item-edit.component';

export interface HealthHistorySectionVM {
  healthHistoryItems: {
    data: HealthHistoryItemVM;
    dropdownOptions: DropdownItem<string>[];
    isEditMode: boolean;
    isNewItem: boolean;
  }[];
  healthHistoryType: HealthHistoryType;
}

@Component({
  selector: 'lib-health-history-section',
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent, HealthHistoryItemComponent, TooltipModule],
  templateUrl: './health-history-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistorySectionComponent {
  public readonly healthHistorySection = input.required<HealthHistorySectionVM>();
  public readonly titleTranslationKey = input.required<string>();
  public readonly emptyTextTranslationKey = input.required<string>();
  public readonly isLoading = input.required<boolean>();
  public readonly addHealthHistoryEnabled = input<boolean>(true);
  public readonly editHealthHistoryEnabled = input<boolean>(true);
  public readonly deleteHealthHistoryEnabled = input<boolean>(true);
  public changeEditMode = output<{ editMode: boolean; itemId: string }>();
  public deleteItem = output<HealthHistoryItemDeleteData>();
  public addNewItem = output<{ type: HealthHistoryType }>();
  public saveItem = output<HealthHistoryItemEditData>();
  public discardNewItem = output<void>();

  public readonly healthHistoryItems = computed(() => this.healthHistorySection().healthHistoryItems);

  protected setEditMode(event: { editMode: boolean; itemId: string }): void {
    this.changeEditMode.emit(event);
  }

  protected onDeleteItem(event: HealthHistoryItemDeleteData): void {
    this.deleteItem.emit(event);
  }

  protected onAddNewItem(): void {
    this.addNewItem.emit({ type: this.healthHistorySection().healthHistoryType });
  }

  protected onSaveItem(event: HealthHistoryItemEditData): void {
    this.saveItem.emit(event);
  }

  protected onDiscardNewItem(): void {
    this.discardNewItem.emit();
  }
}
